function NotFoundPage () {
  return (
    <div className="App">
      <div className={'w-full h-body relative bg-[#313131] flex-center flex-col'}>
        <h1 className='mb-3 text-4xl font-bold text-white'>404 Page not found</h1>
      </div>
    </div>
  )
}

export default NotFoundPage
